module.exports = __webpack_public_path__ + "images/icons/psp/portable-storage/portable-apartment-renters.svg";